// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hpM0n","title":"styles_title__KYjLd"};